// this is the payment link
export const paymentLink  = "https://paystack.com/buy/complete-uiux-course-in-2022-jtnhit"
